import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';

const useSpotlightContentStyles = makeStyles({
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: tokens.spacingVerticalM,
  },
  description: {
    overflow: 'hidden',
  },
  title: {
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightBold,
    lineHeight: tokens.lineHeightBase600,
  },
  badge: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase100,
    ...shorthands.border(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke1Selected),
    backgroundColor: 'transparent',
    marginBottom: tokens.spacingVerticalL,
  },
  badgeText: {
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase100,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
  },
  buttonExternalLink: {
    marginTop: 'auto',
    width: isMobile ? '100%' : 'fit-content',
  },
  mediaContent: {
    width: 'auto',
    objectFit: 'cover',
    display: 'block',
    backfaceVisibility: 'hidden',
    willChange: 'transform',
    height: 'auto',
    maxWidth: '100%',
  },
  mediaContentMobile: {
    objectFit: 'fill',
    height: '100%',
    width: '100%',
  },

  fullSizeContainer: {
    marginTop: tokens.spacingVerticalXL,
    marginBottom: tokens.spacingVerticalM,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    color: tokens.colorNeutralForegroundStaticInverted,

  },
  subtitle1: {
    fontSize: tokens.fontSizeBase300,
  },
  subtitle2: {
    fontWeight: tokens.fontWeightBold,
    fontSize: tokens.fontSizeBase600,
    textTransform: 'uppercase',
  },
  headerFullSize: {
    fontSize: tokens.fontSizeBase400,
  },
  fullSizeSubtitleContainer: {
    marginBottom: tokens.spacingVerticalXXXL,
  },
});

export default useSpotlightContentStyles;
